export default {
  root: ({ instance, context }) => ({
    class: [
      // Font
      'font-sans leading-none',
      'text-xs',
      'w-full',

      // Spacing
      'm-0',
      { 'px-3.5 pb-3': !instance.$attrs['boq-input'] },
      {
        'pt-6':
          (instance.$attrs['has-text'] || instance.$attrs['show-label']) &&
          !instance.$attrs['boq-input'],
        'pt-4': !instance.$attrs['has-text'] && !instance.$attrs['boq-input'],
        'h-8 px-3 pb-3 pt-2 4xl:h-10': instance.$attrs['boq-input'],
      },

      // Shape
      { rounded: instance.$attrs['boq-input'] },
      { 'rounded-lg': !instance.$attrs['boq-input'] },

      // Color and Background
      'bg-transparent border-2',
      'text-txt-800',
      'placeholder:text-txt-600',
      {
        'border-black':
          instance.$attrs['has-text'] && !instance.$attrs['no-label'] && !context.disabled,
      },
      {
        'border-border-border-300': !instance.$attrs['has-text'] && !instance.$attrs['no-label'],
      },
      {
        'border-border-border-300':
          (instance.$attrs['no-label'] && instance.$attrs['has-text']) ||
          (instance.$attrs['no-label'] && !instance.$attrs['has-text']),
      },

      // States
      'focus:outline-none focus:outline-offset-0 focus:ring-0 focus:shadow-none',
      {
        'focus:border-blue-400': !context.disabled,
        'opacity-60 select-none pointer-events-none cursor-default': context.disabled,
      },

      // Misc
      'transition-colors duration-200',
    ],
  }),
};
